<div class="dashboard-pcp">

  <div class="dashboard-pcp__header">
    <div class="dashboard-pcp__title">
      <i class="fi-dashboard-graphic"></i>
      <h1>Dashboard PCP <small>{{ version }}</small></h1>
    </div>
    <div class="dashboard-pcp__filter">
      <label class="dashboard-pcp__filter-label">Período:</label>
      <p-calendar
        [(ngModel)]="periodo"
        selectionMode="range"
        dateFormat="dd/mm/yy"
        [locale]="pt_BR"
        [showIcon]="true"
        [readonlyInput]="true"
        placeholder="Selecione o período"
        (onSelect)="onSelecionarData()"
        inputStyleClass="dashboard-pcp__calendar-input">
      </p-calendar>
    </div>
  </div>

  <div *ngIf="loading" class="dashboard-pcp__loading">
    Carregando dados do dashboard...
  </div>

  <div *ngIf="!loading" class="dashboard-pcp__content">

    <!-- KPI Cards -->
    <div class="dashboard-pcp__kpis">
      <div class="dashboard-pcp__kpi dashboard-pcp__kpi--total">
        <div class="dashboard-pcp__kpi-icon">
          <i class="fi-ecommerce-package-4"></i>
        </div>
        <div class="dashboard-pcp__kpi-info">
          <span class="dashboard-pcp__kpi-value">{{ totalPedidos | number:'1.0-0' }}</span>
          <span class="dashboard-pcp__kpi-label">Total de Pedidos</span>
        </div>
      </div>

      <div class="dashboard-pcp__kpi dashboard-pcp__kpi--producao">
        <div class="dashboard-pcp__kpi-icon">
          <i class="fi-ecommerce-coins"></i>
        </div>
        <div class="dashboard-pcp__kpi-info">
          <span class="dashboard-pcp__kpi-value">{{ emProducao | number:'1.0-0' }}</span>
          <span class="dashboard-pcp__kpi-label">Em Produção</span>
        </div>
      </div>

      <div class="dashboard-pcp__kpi dashboard-pcp__kpi--finalizados">
        <div class="dashboard-pcp__kpi-icon">
          <i class="fi-interface-check-circle"></i>
        </div>
        <div class="dashboard-pcp__kpi-info">
          <span class="dashboard-pcp__kpi-value">{{ finalizados | number:'1.0-0' }}</span>
          <span class="dashboard-pcp__kpi-label">Finalizados</span>
        </div>
      </div>

      <div class="dashboard-pcp__kpi dashboard-pcp__kpi--urgentes">
        <div class="dashboard-pcp__kpi-icon">
          <i class="fi-interface-warning"></i>
        </div>
        <div class="dashboard-pcp__kpi-info">
          <span class="dashboard-pcp__kpi-value">{{ atrasados | number:'1.0-0' }}</span>
          <span class="dashboard-pcp__kpi-label">Atrasados</span>
          <span class="dashboard-pcp__kpi-sub" *ngIf="urgentes > 0">{{ urgentes }} urgentes</span>
        </div>
      </div>
    </div>

    <!-- Gráficos Principais -->
    <div class="dashboard-pcp__charts-row">

      <div class="dashboard-pcp__chart-card dashboard-pcp__chart-card--large">
        <div class="dashboard-pcp__chart-header">
          <h3>Pedidos por Fase</h3>
        </div>
        <div class="dashboard-pcp__chart-body">
          <p-chart type="bar" [data]="dadosFases" [options]="optionsFases" height="320px"></p-chart>
        </div>
      </div>

      <div class="dashboard-pcp__chart-card dashboard-pcp__chart-card--small">
        <div class="dashboard-pcp__chart-header">
          <h3>Status de Produção</h3>
        </div>
        <div class="dashboard-pcp__chart-body dashboard-pcp__chart-body--center">
          <p-chart type="doughnut" [data]="dadosStatus" [options]="optionsStatus" height="320px"></p-chart>
        </div>
      </div>
    </div>

    <!-- Gráficos Complementares -->
    <div class="dashboard-pcp__charts-row">

      <div class="dashboard-pcp__chart-card dashboard-pcp__chart-card--half">
        <div class="dashboard-pcp__chart-header">
          <h3>Produtividade por Técnico</h3>
        </div>
        <div class="dashboard-pcp__chart-body">
          <div *ngIf="dadosTecnicos?.labels?.length > 0">
            <p-chart type="bar" [data]="dadosTecnicos" [options]="optionsTecnicos"
                     [height]="(dadosTecnicos.labels.length * 40 + 60) + 'px'"></p-chart>
          </div>
          <div *ngIf="!dadosTecnicos?.labels?.length" class="dashboard-pcp__empty">
            Nenhum dado de técnico disponível.
          </div>
        </div>
      </div>

      <div class="dashboard-pcp__chart-card dashboard-pcp__chart-card--half">
        <div class="dashboard-pcp__chart-header">
          <h3>Pedidos Urgentes e Atrasados</h3>
        </div>
        <div class="dashboard-pcp__chart-body dashboard-pcp__chart-body--table">
          <p-table [value]="pedidosUrgentes" [scrollable]="true" scrollHeight="320px"
                   styleClass="p-datatable-sm p-datatable-striped"
                   [rows]="20" *ngIf="pedidosUrgentes.length > 0">
            <ng-template pTemplate="header">
              <tr>
                <th>Pedido</th>
                <th>Cliente</th>
                <th>Produto</th>
                <th>Fase</th>
                <th>Entrega</th>
                <th>Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-pedido>
              <tr>
                <td>{{ pedido.numeroPedido }}</td>
                <td class="dashboard-pcp__col-wrap">{{ pedido.nomeCliente }}</td>
                <td class="dashboard-pcp__col-wrap">{{ pedido.descricaoProduto }}</td>
                <td>{{ pedido.processo }}</td>
                <td>
                  <span [class.dashboard-pcp__atrasado]="ehAtrasado(pedido)">
                    {{ formatoData(pedido.dataEntrega) }}
                  </span>
                </td>
                <td>
                  <p-tag [value]="pedido.prioridade === 1 ? 'Urgente' : obterLabelStatus(pedido.statusProducao)"
                         [severity]="pedido.prioridade === 1 ? 'danger' : obterSeverityStatus(pedido.statusProducao)">
                  </p-tag>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div *ngIf="pedidosUrgentes.length === 0" class="dashboard-pcp__empty">
            Nenhum pedido urgente ou atrasado.
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
